export const OPERATOR_EQ = { label: "Igual a", operator: "eq" };
export const OPERATOR_NE = { label: "Diferente de", operator: "ne" };
export const OPERATOR_CONTAINS = { label: "Parecido", operator: "regex" };
export const OPERATOR_NOT_CONTAINS = { label: "Não parecido", operator: "nregex" };
export const OPERATOR_GTE = { label: "Maior/igual que", operator: "gte" };
export const OPERATOR_LTE = { label: "Menor/igual que", operator: "lte" };
export const OPERATOR_GT = { label: "Maior que", operator: "gt" };
export const OPERATOR_LT = { label: "Menor que", operator: "lt" };
export const OPERATOR_IN = { label: "Dentro", operator: "in" };
export const OPERATOR_NOT_IN = { label: "fora", operator: "nin" };

export const setSearchValue = (field, op, text) => {
  return {
    field,
    text,
    operator: op.operator,
  };
};

export const parseDataSearch = (dataSearchArr) => {
    const dataSearch = {};
    for(const item of dataSearchArr){
        dataSearch[item.field] = {text:item.text,operator:item.operator};
    }
    return dataSearch;
};
